
<div class="card-view simulator-section no-border">

  <div class="card-content simulator-wrapper">
    <div class="simulator-content content flex">
      
      <div class="content-text-rigth">
        <h2>Simule a sua <b>economia</b></h2>
        <p>
          Utilize o simulador abaixo para descobrir quanto você pode economizar quando todos os locais do seu dia a dia estão
          conectados na nossa rede de parcerias, assim fazendo o seu salário render mais.
        </p>
      </div>

      <div class="content flex wrapper-form">
        <div class="form-calc">

          <form class="form-caulate-discount">

            <div class="input-range-wrapper">
              <label>Ingressos de cinema:</label>
              <div class="value-discount">
                <input [(ngModel)]="costs.cine" (input)="getEconomyValues(costs)" name="cine" type="text" class="cine input-center" min="0" maxlength="2"/>
              </div>
              <input [(ngModel)]="costs.cine" (input)="getEconomyValues(costs, $event)" name="cine" type="range" class="cine" min="0" max="20" [ngStyle]="{'background-size': '' + valueRangeCine + ''}"/>
            </div>

            <div class="input-range-wrapper">
              <label>Mensalidade da academia:</label>
              <div class="value-discount">
                <span>R$</span><input [(ngModel)]="costs.academy" (input)="getEconomyValues(costs)" name="academy" type="text" class="academy" min="0" maxlength="4"/>
              </div>
              <input [(ngModel)]="costs.academy" (input)="getEconomyValues(costs, $event)" name="academy" type="range" class="academy" min="0" max="2000" [ngStyle]="{'background-size': '' + valueRangeAcademy + ''}"/>
            </div>

            <div class="input-range-wrapper sifra-mini">
              <label>Mensalidade de cursos que você faz (ou pretende fazer):</label>
              <div class="value-discount">
                <span>R$</span><input [(ngModel)]="costs.courses" (input)="getEconomyValues(costs)" name="courses" type="text" class="online" min="0" maxlength="4"/>
              </div>
              <input [(ngModel)]="costs.courses" (input)="getEconomyValues(costs, $event)" name="courses" type="range" class="online" min="0" max="5000" [ngStyle]="{'background-size': '' + valueRangeCourses + ''}"/>
            </div>

            <div class="input-range-wrapper sifra-mini">
              <label>Medicamentos para você e sua família:</label>
              <div class="value-discount">
                <span>R$</span><input [(ngModel)]="costs.medicines" (input)="getEconomyValues(costs)" name="medicines" type="text" class="farmacias" min="0" maxlength="4"/>
              </div>
              <input [(ngModel)]="costs.medicines" (input)="getEconomyValues(costs, $event)" name="medicines" type="range" class="farmacias" min="0" max="2000" [ngStyle]="{'background-size': '' + valueRangeMedicines + ''}"/>
            </div>

            <div class="input-range-wrapper sifra-mini">
              <label>Mensalidade da escola dos seus filhos:</label>
              <div class="value-discount">
                <span>R$</span><input [(ngModel)]="costs.school" (input)="getEconomyValues(costs)" name="school" type="text" class="universidades" min="0" maxlength="5"/>
              </div>
              <input [(ngModel)]="costs.school" (input)="getEconomyValues(costs, $event)" name="school" type="range" class="universidades" min="0" max="8000" [ngStyle]="{'background-size': '' + valueRangeSchool + ''}"/>
            </div>
            
            <div class="input-range-wrapper sifra-mini">
              <label>Restaurantes:</label>
              <div class="value-discount">
                <span>R$</span><input [(ngModel)]="costs.restaurants" (input)="getEconomyValues(costs)" name="restaurants" type="text" class="restaurants" min="0" maxlength="4"/>
              </div>
              <input [(ngModel)]="costs.restaurants" (input)="getEconomyValues(costs, $event)" name="restaurants" type="range" class="restaurants" min="0" max="2000" [ngStyle]="{'background-size': '' + valueRangeRestaurants + ''}"/>
            </div>


          </form>
        </div>
        <div class="total-calc" style="background-image: url('https://allya-images.s3.us-east-1.amazonaws.com/m/site/simule/calc_simulate.png');">
          <p>Fechando parcerias nos lugares do seu dia-a-dia, você poderá economizar até...</p>
          <p class="🤑">
            <strong>R$ {{economyValue}}</strong>
          </p>
          <p>...utilizando a Allya.</p>
        </div>
      </div>

    </div>
  </div>

</div>